module.exports = __webpack_public_path__ + "static/media/tip_text_cat_topical_fr.64df1edb.svg";